const dev = {
  PLATFORM: 'preprod',
  API_URL: 'http://localhost:3000',
  CLIENT_URL: 'http://localhost:3001',
  UI_URL: 'http://localhost:3030',
  MEDIA_URL: 'http://localhost/media',
  OBJECT_URL: 'https://cdn.englishworld-learning.fr',
  LRS_ENDPOINT: 'http://localhost:3000/xAPI/',
};

const preprod = {
  PLATFORM: 'preprod',
  API_URL: 'https://api-preprod.englishworld-learning.fr',
  CLIENT_URL: 'https://client-preprod.englishworld-learning.fr',
  UI_URL: 'https://preprod.englishworld-learning.fr',
  MEDIA_URL: 'https://cdn.englishworld-learning.fr',
  OBJECT_URL: 'https://cdn.englishworld-learning.fr',
  LRS_ENDPOINT: 'https://api-preprod.englishworld-learning.fr/xAPI/',
};

const config = process.env.NODE_ENV === 'development' ? dev : preprod;

export default config;
